import React, { useState, useEffect } from "react";
import api from "../../../services/api";
//import "../../../../styles/global.css";
import "./RoutesDetails.css";
import styles from "./RoutesDetails.module.css";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import IssueCheckModal from "./components/IssueCheckModal";
import ScannedCodesModal from './components/ScannedCodesModal';
 
const COLUMN_TYPE = "COLUMN";

const DEFAULT_COLUMNS = [
  { key: "receipt_number", label: "№ квитанции", visible: true },
  { key: "contract_number", label: "№ договора", visible: true },
  { key: "time", label: "Время", visible: true },
  { key: "delivery_time", label: "Время доставки", visible: true },
  { key: "delivery_address", label: "Адрес доставки", visible: true },
  { key: "client_name", label: "Клиент", visible: true },
  { key: "amount", label: "Сумма", visible: true },
  { key: "to_pay", label: "К оплате", visible: true },
  { key: "paid", label: "Оплачено", visible: true },
  { key: "payment_type", label: "Тип оплаты", visible: true },
  { key: "status", label: "Статус", visible: true },
  { key: "reason", label: "Причина", visible: true },
  { key: "is_check_issued", label: "Чек", visible: true },
  { key: "scannedCount", label: "Скан", visible: true },
  { key: "products", label: "Товары", visible: true },
];

const STATUS_COLORS = {
  "Открыта": "#007bff",
  "Закрыта": "#28a745",
  "Не доставлено": "#dc3545"
};

// Функция для расчёта статусов квитанций и общего количества заказов
const getProgress = (receipts) => {
  if (!Array.isArray(receipts)) {
    return { delivered: 0, inProgress: 0, undelivered: 0, totalOrders: 0 };
  }
  const totalOrders = receipts.length;
  const delivered = receipts.filter((receipt) => receipt.status === "Закрыта")
    .length;
  const inProgress = receipts.filter((receipt) => receipt.status === "Открыта")
    .length;
  const undelivered = receipts.filter(
    (receipt) => receipt.status === "Не доставлено"
  ).length;
  return { delivered, inProgress, undelivered, totalOrders };
};

const RoutesDetails = () => {
  const [routes, setRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [columns, setColumns] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const [showIssueCheckModal, setShowIssueCheckModal] = useState(false);
  const [selectedReceiptId, setSelectedReceiptId] = useState(null);

  const [showCodesModal, setShowCodesModal] = useState(false);
  const [codesForMark, setCodesForMark] = useState([]);


  const openIssueCheckModal = (receiptId) => {
    // Здесь можно сохранить ID квитанции, для которой нужно пробить чек, если потребуется
    setShowIssueCheckModal(true);
  };

  // Пример закрытия модального окна
  const closeIssueCheckModal = () => {
    setShowIssueCheckModal(false);
  };

  // Загрузка колонок из localStorage
  useEffect(() => {
    try {
      const savedColumns = JSON.parse(localStorage.getItem("dispatcherColumns"));
      if (savedColumns && Array.isArray(savedColumns)) {
        // Добавляем новые колонки, отсутствующие в сохранённом наборе
        const mergedColumns = [
          ...savedColumns,
          ...DEFAULT_COLUMNS.filter(
            (defaultCol) => !savedColumns.find((col) => col.key === defaultCol.key)
          ),
        ];
        setColumns(mergedColumns);
        localStorage.setItem("dispatcherColumns", JSON.stringify(mergedColumns));
      } else {
        throw new Error("Неверные данные");
      }
    } catch (error) {
      console.error(error.message);
      setColumns(DEFAULT_COLUMNS);
      localStorage.setItem("dispatcherColumns", JSON.stringify(DEFAULT_COLUMNS));
    }
  }, []);
  

  useEffect(() => {
    if (columns.length > 0) {
      localStorage.setItem("dispatcherColumns", JSON.stringify(columns));
    }
  }, [columns]);

  // Загрузка маршрутов с учетом диапазона дат
  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const response = await api.get("/routes/by-date", {
          params: {
            startDate: startDate.toISOString().split("T")[0],
            endDate: endDate.toISOString().split("T")[0],
          },
        });
        setRoutes(response || []);
      } catch (err) {
        console.error("Ошибка загрузки маршрутов", err);
      }
    };
    fetchRoutes();
  }, [startDate, endDate]);

  const filteredReceipts =
    selectedRoute?.receipts.filter((receipt) =>
      Object.values(receipt)
        .filter(
          (value) => typeof value === "string" || typeof value === "number"
        )
        .some((value) =>
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    ) || [];

  // Сортировка (как в 1С: ▲ → ▼ → сброс)
  const sortedReceipts = [...filteredReceipts].sort((a, b) => {
    if (!sortColumn) return 0;

    // Числовые поля сравниваем как числа
    if (["amount", "to_pay", "paid"].includes(sortColumn)) {
      const va = Number(a[sortColumn]) || 0;
      const vb = Number(b[sortColumn]) || 0;
      // если asc, сортируем по возрастанию, иначе по убыванию
      return sortOrder === "asc" ? va - vb : vb - va;
    }

    let valueA = a[sortColumn] ?? "";
    let valueB = b[sortColumn] ?? "";

    if (typeof valueA === "string") valueA = valueA.toLowerCase();
    if (typeof valueB === "string") valueB = valueB.toLowerCase();

    if (sortOrder === "asc") return valueA > valueB ? 1 : -1;
    if (sortOrder === "desc") return valueA < valueB ? 1 : -1;
    return 0;
    
  });

  const handleSort = (column) => {
    if (sortColumn === column) {
      if (sortOrder === "asc") setSortOrder("desc");
      else if (sortOrder === "desc") setSortOrder(null);
      else setSortOrder("asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

   // Обновление статуса квитанции
// Обновление статуса квитанции с указанием причины
const handleStatusChange = async (receiptId, newStatus) => {
  try {
    // Формируем тело запроса
    const payload = { status: newStatus };

    if (newStatus === "Закрыта") {
      payload.reason = "Закрыта диспетчером";
    } else if (newStatus === "Не доставлено") {
      payload.reason = "Снята диспетчером";
    } else if (newStatus === "Открыта") {
      payload.reason = "";  // при открытии причину очищаем
    }

    // Отправляем на бэкенд
    await api.patch(`/receipts/${receiptId}/status`, payload);

    // Обновляем локальное состояние
    setRoutes(prev =>
      prev.map(route =>
        route.id === selectedRoute.id
          ? {
              ...route,
              receipts: route.receipts.map(r =>
                r.id === receiptId
                  ? { ...r, status: newStatus, reason: payload.reason }
                  : r
              )
            }
          : route
      )
    );

    setSelectedRoute(sr =>
      sr && {
        ...sr,
        receipts: sr.receipts.map(r =>
          r.id === receiptId
            ? { ...r, status: newStatus, reason: payload.reason }
            : r
        )
      }
    );
  } catch (err) {
    console.error("Ошибка обновления статуса", err);
  }
};


  const handleCheckClick = (receiptId) => {
    setSelectedReceiptId(receiptId);
    setShowIssueCheckModal(true);
  };

const handleCheckIssued = (issuedReceiptId) => {
  if (!selectedRoute) return;

  // Обновляем список маршрутов
  setRoutes(prevRoutes =>
    prevRoutes.map(route =>
      route.id === selectedRoute.id
        ? {
            ...route,
            receipts: route.receipts.map(r =>
              r.id === issuedReceiptId
                ? {
                    ...r,
                    is_check_issued: true,
                    status: 'Закрыта'     // <-- здесь ставим закрыт
                  }
                : r
            )
          }
        : route
    )
  );

  // Обновляем текущий выбранный маршрут
  setSelectedRoute(sr =>
    sr && {
      ...sr,
      receipts: sr.receipts.map(r =>
        r.id === issuedReceiptId
          ? {
              ...r,
              is_check_issued: true,
              status: 'Закрыта'     // <-- и тут
            }
          : r
      )
    }
  );
};


  
  

  const toggleColumnVisibility = (key) => {
    setColumns((prev) =>
      prev.map((col) => (col.key === key ? { ...col, visible: !col.visible } : col))
    );
  };

  const moveColumn = (dragIndex, hoverIndex) => {
    setColumns((prevColumns) => {
      const visibleColumns = prevColumns.filter((col) => col.visible);

      // Получаем ключи столбцов
      const draggedColKey = visibleColumns[dragIndex].key;
      const hoverColKey = visibleColumns[hoverIndex].key;

      // Получаем индексы этих колонок в общем массиве `columns`
      const realDragIndex = prevColumns.findIndex((col) => col.key === draggedColKey);
      const realHoverIndex = prevColumns.findIndex((col) => col.key === hoverColKey);

      // Меняем их местами
      const updatedColumns = [...prevColumns];
      const [movedColumn] = updatedColumns.splice(realDragIndex, 1);
      updatedColumns.splice(realHoverIndex, 0, movedColumn);

      // Сохраняем изменения в localStorage
      localStorage.setItem("dispatcherColumns", JSON.stringify(updatedColumns));
      return updatedColumns;
    });
  };

  const Column = ({ index, column }) => {
    const ref = React.useRef(null);

    const [{ isDragging }, drag] = useDrag({
      type: COLUMN_TYPE,
      item: { index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    const [, drop] = useDrop({
      accept: COLUMN_TYPE,
      hover: (draggedItem, monitor) => {
        const dragIndex = draggedItem.index;
        const hoverIndex = index;

        if (dragIndex === hoverIndex) return;

        const hoverBoundingRect = ref.current?.getBoundingClientRect();
        if (!hoverBoundingRect) return;

        const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
        const mouseX = monitor.getClientOffset().x - hoverBoundingRect.left;

        if (dragIndex < hoverIndex && mouseX < hoverMiddleX) return;
        if (dragIndex > hoverIndex && mouseX > hoverMiddleX) return;

        moveColumn(dragIndex, hoverIndex);
        draggedItem.index = hoverIndex;
      },
    });

    drag(drop(ref));

    return (
      <th
        ref={ref}
        style={{
          cursor: "grab",
          opacity: isDragging ? 0.5 : 1,
          transition: "opacity 0.2s ease-in-out",
        }}
        onClick={() => handleSort(column.key)}
      >
        {column.label}{" "}
        {sortColumn === column.key
          ? sortOrder === "asc"
            ? "▲"
            : sortOrder === "desc"
            ? "▼"
            : ""
          : ""}
      </th>
    );
  };


    // Подсчет отсканированных марок по товарам квитанции
    const getMarksInfo = (receipt) => {
      let totalExpected = 0;
      let scannedCount = 0;
      receipt.products.forEach((product) => {
        if (product.is_marked) {
          totalExpected += product.actual_quantity;
          scannedCount += product.marks ? product.marks.length : 0;
        }
      });
      return { scannedCount, totalExpected };
    };

return (
  <DndProvider backend={HTML5Backend}>
    <div className={styles.dispatcherContainer}>
      <aside className={styles.dispatcherSidebar}>
        <div className={styles.dispatcherDateFilterRow}>
          <label>
            С:   
            <input
              type="date"
              value={isNaN(startDate.getTime()) ? '' : startDate.toISOString().split("T")[0]}
              onChange={(e) => setStartDate(new Date(e.target.value))}
            />
          </label>
          <label>
            По:
            <input
              type="date"
              value={isNaN(endDate.getTime()) ? '' : endDate.toISOString().split("T")[0]}
              onChange={(e) => setEndDate(new Date(e.target.value))}
            />
          </label>
        </div>

        <ul className={styles.routesList}>
          {routes.map((route) => {
            const { delivered, inProgress, undelivered, totalOrders } = getProgress(route.receipts);
            const deliveredWidth = totalOrders > 0 ? (delivered / totalOrders) * 100 : 0;
            const inProgressWidth = totalOrders > 0 ? (inProgress / totalOrders) * 100 : 0;
            const undeliveredWidth = totalOrders > 0 ? (undelivered / totalOrders) * 100 : 0;

            return (
              <li
                key={route.id}
                onClick={() => setSelectedRoute(route)}
                className={`${styles.routeItem} ${selectedRoute?.id === route.id ? styles.selected : ''}`}
              >
                <div>
                  Маршрут №{route.route_number} | Водитель: {route.driver} | Районы: {route.route_districts} ({route.route_date})
                </div>
                {/* Прогресс-бар */}
                <div className={styles.progressContainer}>
                  <div className={styles.progressBar}>
                    <div
                      className={styles.progressDelivered}
                      style={{ width: `${deliveredWidth}%` }}
                    />
                    <div
                      className={styles.progressInProgress}
                      style={{ width: `${inProgressWidth}%` }}
                    />
                    <div
                      className={styles.progressUndelivered}
                      style={{ width: `${undeliveredWidth}%` }}
                    />
                  </div>
                  <div className={styles.statusText}>
                    <span>{delivered}/{totalOrders} доставлено</span>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </aside>
        

        <main className="route-details">
          <div className={styles.columnSettings}>
            <h3></h3>
            {columns.map((col) => (
              <label key={col.key}>
                <input
                  type="checkbox"
                  checked={col.visible}
                  onChange={() => toggleColumnVisibility(col.key)}
                />
                {col.label}
              </label>
            ))}
          </div>
          {selectedRoute ? (
            <>
              <h2>Маршрут №{selectedRoute.route_number}</h2>
              <h3>
                Маршрут №{selectedRoute.route_number} | Водитель{" "}
                {selectedRoute.driver}
              </h3>
              <h3>Районы: {selectedRoute.route_districts}</h3>

              <input
                type="text"
                className="search-input2"
                placeholder="Введите текст для поиска..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <table className="dispatcher-receipts-table">
                <thead>
                  <tr>
                    {columns
                      .filter((col) => col.visible)
                      .map((col, index) => (
                        <Column key={col.key} index={index} column={col} />
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {sortedReceipts.length > 0 ? (
                    sortedReceipts.map((receipt) => {
                      const { scannedCount, totalExpected } = getMarksInfo(receipt);
                      return (
                        <tr key={receipt.id}>
                          {columns
                            .filter(col => col.visible)
                            .map(col => {
                              // 1) Спец-рендер для статуса
                              if (col.key === "status") {
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      backgroundColor: STATUS_COLORS[receipt.status],
                                      padding: "5px",
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <select
                                      value={receipt.status}
                                      onChange={e => handleStatusChange(receipt.id, e.target.value)}
                                      className="status-select"
                                    >
                                      {Object.keys(STATUS_COLORS).map(label => (
                                        <option key={label} value={label}>
                                          {label}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                );
                              }
                              // 2) Рендер для чеков
                              else if (col.key === "is_check_issued") {
                                return (
                                  <td key={col.key}>
                                    <span
                                      onClick={() => {
                                        if (
                                          ["ПоСчету", "Кредит", "Взаимозачет", "Дилер", "БезОплаты"].includes(
                                            receipt.payment_type
                                          )
                                        ) {
                                          return;
                                        }
                                        if (!receipt.is_check_issued && !receipt.is_check_refunded) {
                                          setSelectedReceiptId(receipt.id);
                                          setShowIssueCheckModal(true);
                                        } else {
                                          handleCheckClick(receipt.id);
                                        }
                                      }}
                                      style={{
                                        cursor: ["ПоСчету", "Кредит", "Взаимозачет", "Дилер", "БезОплаты"].includes(
                                          receipt.payment_type
                                        )
                                          ? "default"
                                          : "pointer",
                                      }}
                                    >
                                      {["ПоСчету", "Кредит", "Взаимозачет", "Дилер", "БезОплаты"].includes(
                                        receipt.payment_type
                                      )
                                        ? "Чек не нужен"
                                        : receipt.is_check_refunded
                                        ? "Возвращён"
                                        : receipt.is_check_issued
                                        ? "Пробит"
                                        : "-"}
                                    </span>
                                  </td>
                                );
                              }
                              // 3) Рендер для остальных колонок
                              else {
                                return (
                                  <td key={col.key}>
                                    {col.key === "products"
                                      ? receipt.products.map(p => `${p.product_name} x${p.actual_quantity}`).join(", ")
                                      : col.key === "scannedCount"
                                      ? (
                                        <span
                                          onClick={() => {
                                            const codes = receipt.products.flatMap(p => p.marks || []);
                                            setCodesForMark(codes);
                                            setShowCodesModal(true);
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {`${scannedCount} / ${totalExpected}`}
                                        </span>
                                      )
                                      : receipt[col.key]
                                    }
                                  </td>
                                );
                              }
                            })}

                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.filter(col => col.visible).length} className="no-results">
                        Нет квитанций, соответствующих поиску.
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </>
          ) : (
            <p>Выберите маршрут для просмотра информации</p>
          )}
        </main>
      </div>
      {showIssueCheckModal && (
      <div className="modal-wrapper" onClick={() => setShowIssueCheckModal(false)}>
        <div className="modal-container" onClick={(e) => e.stopPropagation()}>
          <IssueCheckModal
            receiptId={selectedReceiptId}
            onClose={() => setShowIssueCheckModal(false)}
            onCheckIssued={handleCheckIssued}
          />
        </div>
  </div>
)}
{showCodesModal && (
  <ScannedCodesModal
    codes={codesForMark}
    onClose={() => setShowCodesModal(false)}
  />
)}


  </DndProvider>
);
};

export default RoutesDetails;
